import { render, staticRenderFns } from "./colikado-summary-by-product-type.vue?vue&type=template&id=5124fc8a&"
import script from "./colikado-summary-by-product-type.vue?vue&type=script&lang=js&"
export * from "./colikado-summary-by-product-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports